"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("material-ui/CircularProgress"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Loader = function Loader(props) {
  var size = props.size,
    thickness = props.thickness,
    className = props.className,
    message = props.message;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader ".concat(className)
  }, message ? /*#__PURE__*/_react["default"].createElement("h3", null, message) : /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    className: "progress-indicator",
    size: size || 60,
    thickness: thickness || 8
  }));
};
var _default = Loader;
exports["default"] = _default;